import { TransactionHistory } from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

export default function route() {
  return [
    {
      path: adminRouteMap.TRANSACTION_HISTORY.path,
      name: "Transaction History",
      key: adminRouteMap.TRANSACTION_HISTORY.path,
      private: true,
      belongsToSidebar: true,
      icon: adminRouteMap.TRANSACTION_HISTORY.icon,
      element: <TransactionHistory />,
    },
  ];
}
